import { Plus, Eye, Smartphone, AlertTriangle, Package } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import AddModelModal from "./AddModelModal"
import { useDispatch, useSelector } from "react-redux"
import { modelsData } from "../../store/actions"

export default function Models() {
    const modelsdata = useSelector((state: any) => state.UserReducer.modelsdata);
    const userdata = useSelector((state: any) => state.UserReducer.userdata);

    const { user, store } = userdata;
    const models = modelsdata.data;
    const stats = modelsdata.stats;
    const pagination = modelsdata?.pagination || {}

    console.log({ models, stats, modelsdata })

    const { totalPages = 1, page: currentPage = 1 } = pagination

    const navigate = useNavigate()

    const [modelList, setModelList] = useState<any[]>([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [page, setPage] = useState(1);
    const limit = 6;

    const dispatch = useDispatch();


    const existingModels = modelList && modelList?.map((m: any) => m.name.toLowerCase())
    // const existingModels: any = [];

    useEffect(() => {
        if (store) dispatch(modelsData(store?._id, page, limit))
    }, [store, page]);

    useEffect(() => {
        setModelList(modelsdata.data || [])
    }, [modelsdata]);

    console.log({ modelsdata });

    return (
        <>
            <div className="space-y-10">

                {/* Header */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-800">
                            Modèles
                        </h1>
                        <p className="text-sm text-gray-500">
                            Vue centrale du stock par modèle
                        </p>
                    </div>

                    <button
                        onClick={() => setIsModalOpen(true)}
                        className="
            inline-flex items-center gap-2
            bg-blue-600 hover:bg-blue-700
            text-white px-5 py-2.5 rounded-xl
            shadow-sm transition
          "
                    >
                        <Plus size={18} />
                        Ajouter un modèle
                    </button>
                </div>

                {/* KPI */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                    <Kpi
                        label="Modèles"
                        value={stats?.totalModels}
                        icon={<Smartphone size={22} />}
                        accent="bg-indigo-600"
                    />
                    <Kpi
                        label="Téléphones en stock"
                        value={stats?.totalPhonesInStock}
                        icon={<Package size={22} />}
                        accent="bg-blue-600"
                    />
                    <Kpi
                        label="Valeur achat stock"
                        value={`${stats?.totalStockValue.toLocaleString()} FCFA`}
                        icon={<AlertTriangle size={22} />}
                        accent="bg-emerald-600"
                    />
                </div>

                {/* Desktop Table */}
                <div className="hidden md:block bg-white rounded-2xl shadow-sm border overflow-hidden">
                    <table className="w-full text-sm">
                        <thead className="bg-gray-50">
                            <tr className="text-left text-gray-500">
                                <th className="px-6 py-3">Modèle</th>
                                <th className="px-6 py-3">Marque</th>
                                <th className="px-6 py-3">Stock</th>
                                <th className="px-6 py-3">Valeur achat</th>
                                <th className="px-6 py-3 text-right">Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {modelList && modelList?.map((model: any) => {

                                return (
                                    <tr
                                        key={model._id}
                                        className="border-t hover:bg-gray-50 transition"
                                    >
                                        <td className="px-6 py-4 font-medium text-gray-800 flex items-center gap-2">
                                            <Smartphone size={16} />
                                            {model.name}
                                        </td>

                                        <td className="px-6 py-4 text-gray-600">
                                            {model.brand}
                                        </td>

                                        <td className="px-6 py-4 space-y-1">
                                            <div className="flex items-center gap-2">
                                                <span
                                                    className={`font-semibold ${model.stockCount > 0 && model.stockCount < 3
                                                        ? "text-red-600"
                                                        : "text-gray-800"
                                                        }`}
                                                >
                                                    {model.stockCount}
                                                </span>

                                                {model.stockCount > 0 && model.stockCount < 3 && (
                                                    <span className="text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded-full">
                                                        Stock faible
                                                    </span>
                                                )}
                                            </div>

                                            <div className="h-1.5 bg-gray-100 rounded">
                                                <div
                                                    className={`h-1.5 rounded ${model.stockCount < 3 ? "bg-red-500" : "bg-green-500"
                                                        }`}
                                                    style={{ width: `${Math.min(model.stockCount * 10, 100)}%` }}
                                                />
                                            </div>
                                        </td>

                                        <td className="px-6 py-4 text-gray-600">
                                            {model.stockBuyValue?.toLocaleString()} FCFA
                                        </td>


                                        <td className="px-6 py-4 text-right">
                                            <button
                                                onClick={() =>
                                                    navigate(`/phones?model=${model._id}`)
                                                }
                                                className="
                        inline-flex items-center gap-2
                        px-3 py-1.5 rounded-lg
                        border hover:bg-gray-100 transition
                      "
                                            >
                                                <Eye size={16} />
                                                Voir
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>

                </div>

                {/* Mobile Cards */}
                <div className="space-y-4 md:hidden">
                    {modelList && modelList?.map((model: any) => {

                        return (
                            <div
                                key={model._id}
                                className="bg-white rounded-2xl shadow-sm border p-4 space-y-3"
                            >
                                <div className="flex justify-between items-start">
                                    <div>
                                        <p className="font-semibold text-gray-800">
                                            {model.name}
                                        </p>
                                        <p className="text-xs text-gray-500">
                                            {model.brand}
                                        </p>
                                    </div>

                                    <span
                                        className={`px-3 py-1 rounded-full text-xs ${model.stockCount < 3
                                            ? "bg-red-100 text-red-600"
                                            : "bg-green-100 text-green-700"
                                            }`}
                                    >
                                        {model.stockCount} en stock
                                    </span>

                                </div>

                                <div className="flex justify-between text-sm">
                                    <span className="text-gray-500">Valeur achat</span>
                                    <span className="font-medium">
                                        {model.stockBuyValue?.toLocaleString()} FCFA
                                    </span>
                                </div>

                                <button
                                    onClick={() =>
                                        navigate(`/phones?model=${model.name}`)
                                    }
                                    className="
                  w-full inline-flex justify-center items-center gap-2
                  border rounded-xl py-2 hover:bg-gray-50 transition
                "
                                >
                                    <Eye size={16} />
                                    Voir téléphones
                                </button>
                            </div>
                        )
                    })}
                </div>


                {/* Pagination */}
                {pagination.totalPages > 1 && (
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-4">

                        <p className="text-sm text-gray-500">
                            Page {pagination.page} sur {pagination.totalPages}
                        </p>

                        <div className="flex gap-2">
                            <button
                                disabled={page === 1}
                                onClick={() => setPage(p => p - 1)}
                                className="
                                    px-4 py-2 rounded-xl border
                                    disabled:opacity-50
                                    hover:bg-gray-100 transition
                                "
                            >
                                Précédent
                            </button>

                            <button
                                disabled={page === pagination.totalPages}
                                onClick={() => setPage(p => p + 1)}
                                className="
                                    px-4 py-2 rounded-xl
                                    bg-blue-600 text-white
                                    disabled:opacity-50
                                    hover:bg-blue-700 transition
                                "
                            >
                                Suivant
                            </button>
                        </div>
                    </div>
                )}
            </div>

            <AddModelModal
                currentStore={store}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                existingModels={existingModels}
                // onAdd={(newModel) =>
                //     setModelList(prev => [newModel, ...prev])
                // }
                onCreated={(model) => {
                    dispatch(modelsData(store?._id, page, limit))
                    setModelList((prev: any) => [model, ...prev])
                }
                }
            />


        </>
    )
}

/* ---------- Components ---------- */

function Kpi({
    label,
    value,
    icon,
    accent,
}: {
    label: string
    value: string | number
    icon: React.ReactNode
    accent: string
}) {
    return (
        <div className="bg-white rounded-2xl shadow-sm border p-5 flex items-center justify-between">
            <div>
                <p className="text-sm text-gray-500">{label}</p>
                <p className="text-2xl font-bold text-gray-800">{value}</p>
            </div>

            <div
                className={`h-12 w-12 rounded-xl ${accent} text-white flex items-center justify-center`}
            >
                {icon}
            </div>
        </div>
    )
}
